import BreadCrumb from "Common/BreadCrumb";
import { axios_helper_async } from "helpers/Axios";
import { Brands } from "Common/Models/Brands";
import { Category } from "Common/Models/Category";
import { MessageTypes } from "Common/constants/MessageEnums";
import withMessages from "Common/withMessages";
import withNotifications, { WithNotificationsProps } from "Common/withNotifications";
import withOverlay, { WithOverlayProps } from "Common/withOverlay";
import { Search } from "lucide-react";
import React, { useEffect, useState } from "react";
import { WithMessagesProps } from '../../Common/withMessages';
import { WithTranslationProps } from "Common/Components/Translation/WithTranslationProps";
import withTranslation from "Common/withTranslation";
import Card from "Common/Components/Card/Card";
import product1 from "assets/images/Index.resources/SpareParts_2.jpg"
import OrderByAlfaNumeric from "Common/constants/CategoryNames";
import CardCaretory from "Common/Components/Card/Categories/CardCategory";
import AlphabeticList from "Common/Components/AlphabeticList/AlphabeticList";
import { NotificationType } from "Common/Components/Notifications/notificationTypes";
import LoadingOverlay from "Common/Components/LoadingOverlay/LoadingOverlay";
import Title from "Common/Components/Titles/Title";
import { CategoryDetails } from "Common/Models/CategoryDetails";

const CategoriesPage: React.FC<WithMessagesProps & WithNotificationsProps & WithTranslationProps> = ({ 
    messages,
    notifications,
    i18n,
    t 
}) => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [titles, setTitles] = useState<string[]>([]);
    const [categories, setCategories] = useState<CategoryDetails[]>([]);

    const GetCategories = async () => {
        try {
            setIsLoading(true);
            const body = {
                language: i18n.language
            }
            let response = await axios_helper_async<CategoryDetails[]>('/SOI/Get-Categories-Details', 'GET', body);
    
            messages.setMessages(response.messages);
            notifications.setNotifications(response.notifications);
    
            if (response.isSuccess && response.data) {                
                setCategories(response.data);
                setTitles(OrderByAlfaNumeric(response.data.map(x => x.name)));
            }
        }
        catch(err: any) {
            notifications.showNotification('Categories.Errors.GetCategories', NotificationType.Error);
        }
        finally {
            setIsLoading(false);
        }
    };

    const handleLanguageChange = async (lng: string) => {
        await GetCategories();
    };

    useEffect(() => {
        //console.log(titles);
    }, [titles])

    useEffect(() => {
        (async () => {
            await GetCategories();
        })();
    }, []);

    useEffect(() => {
        i18n.on('languageChanged', handleLanguageChange);

        return () => {
            i18n.off('languageChanged', handleLanguageChange);
        };
    }, []);

    return (
        <React.Fragment>
            <div className="flex flex-col justify-center items-center w-full gap-4">
                {isLoading ? 
                    <LoadingOverlay />
                    :
                    <>
                        <Title text={t('General.Categories')} />
                        <AlphabeticList list={titles} />
                        {categories.length > 0 && <a href={`/Category?category=${0}`} className="text-center w-full text-md font-bold italic underline text-blue-500">{t('Categories.ViewAllProducts')}</a>}
                        <div className="flex flex-col grow gap-2 w-full">
                            {titles.map((title) => {
                                return (
                                    <div id={title} key={title} className="space-y-2">
                                        <div className="flex justify-center items-center">
                                            <h1 className="font-bold text-xl">{title}</h1>
                                        </div>
                                        <div className="grid grid-cols-2 md:grid-cols-6 gap-1">
                                            {categories.map((category, index) => {
                                                return (
                                                    category.name.toUpperCase().startsWith(title) && (
                                                        <CardCaretory
                                                            key={index}
                                                            img={category.image}
                                                            paragraph={category.description}
                                                            tooltip={true}
                                                            title={category.name}
                                                            width={150}
                                                            height={150}
                                                            link={`/Category?category=${category.id}`}
                                                        />
                                                    )
                                                );
                                            })}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </>
                }
            </div>
        </React.Fragment>
    );
}

export default withTranslation(withNotifications(withMessages(CategoriesPage)));